.jv{gap:0.125rem;}